import React, { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material';

const Scrollable: ComponentType<HTMLAttributes<HTMLDivElement>> = styled('div')({
  overflow: 'auto',
  scrollbarGutter: 'stable',
  paddingLeft: 10,
  marginBottom: 10,
  marginRight: 2,
  '&::-webkit-scrollbar': {
    width: 8,
  },
  '&::-webkit-scrollbar-track': {
    background: '#FFFFFF',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#C8C8C8',
    borderLeft: '2px solid #FFFFFF',
    borderRight: '2px solid #FFFFFF',
    '&:hover': {
      background: '#ABABAB',
    }
  },
});

export default Scrollable;
